import JQuery from "jquery";
import { OUTLINE_TEXT } from "../4-one-of-one/_selectors";
import generateCanvas from "../4-one-of-one/generateCanvas";
import { colors } from "../constants/colors";
import { OUTLINE_REMOVE_BUTTON } from "../constants/selectors";
import selectSingleElement from "../dom/selectSingleElement";

function scriptInputSetup(scriptInput: HTMLInputElement, outlineClicked: boolean) {
	if (scriptInput === null) {
		scriptInput = document.querySelector(".pplr-script-text input") as HTMLInputElement;
	}

	scriptInput.addEventListener("change", function scriptTextChange(e) {
		console.log("script text changing");
		const target = e.target as HTMLInputElement;
		const text = target.value;
		generateCanvas({
			color: "transparent",
			text: "",
			id: "outline",
			withStroke: true,
		});
		const outlineRemoveBtn = selectSingleElement<HTMLAnchorElement>(OUTLINE_REMOVE_BUTTON);
		if (outlineRemoveBtn !== null) {
			JQuery(outlineRemoveBtn).trigger("click");
		}
		if (outlineClicked === true) {
			const defaultColor = colors.currentColor[0];
			const outlineInput = selectSingleElement<HTMLInputElement>(OUTLINE_TEXT);
			if (outlineInput) outlineInput.value = text;
			generateCanvas({
				color: defaultColor,
				text,
				id: "outline",
				withStroke: true,
			});
		}
	});
}

export default scriptInputSetup;
